import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Podium(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#333333" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path d="M7 6V13.0724L10.4264 18H14.3951L12.316 13.0724H17V6H7V6Z" fill="white" />
    </svg>
  );
}

Podium.propTypes = propTypes;
Podium.defaultProps = defaultProps;

export default Podium;
